module.exports = __webpack_public_path__ + "img/writingSeminar_041022_I.da221d50.jpg";